<template>
  <div class="promoted-result" :class="{hidden: !result}">
    <div class="result-text">
      <h5 v-if="result">{{result.title}}</h5>
      <div class="promoted-description"></div>

      <ul class="links" v-if="result">
        <li v-for="l in result.links">
          <a :href="l.url" :title="l.title" :class="linkClass">{{l.title}}</a>
        </li>
      </ul>
    </div>
    <div
      class="result-image"
      v-if="result && result.image"
      :style="'background-image:url('+result.image+')'"
    ></div>
  </div>
</template>

<script>
import "es6-promise/auto";
import { Bus } from "./services/bus.js";
import { Labels } from "./services/labels.js";
import { Settings } from "./services/settings.js";
import { Utils } from "./services/utils.js";
import axios from "axios";
import { SessionState } from "./services/session-state.js";

export default {
  name: "PromotedResult",
  components: {},
  data() {
    return {
      labels: Labels,
      currentQuery: "",
      result: null,
      isLoading: false
    };
  },
  created() {
    Bus.$on("start-search", this.search);
  },
  beforeDestroy() {
    Bus.$off("start-search");
  },
  mounted() {},
  computed: {
    linkClass () {
      if (this.result.renderAsButtons) {
        return "button blue inline-left";
      } else {
        return "regular-link";
      }
    }
  },
  methods: {
    search(filters) {
      var oThis = this;
      if (!filters.query || filters.query.length < 3) {
        oThis.result = null;
        return;
      }
      oThis.currentQuery = filters.query;
      console.log("Searching for promoted results with " + filters.query);
      oThis.isLoading = true;

      var url = Utils.constructPromotedResultUrl(filters.query);
      axios
        .get(url)
        .then(function(response) {
          oThis.result = response.data;
          oThis.$nextTick(() => {
            //hack: put the description value directly in the DOM, to counter the fact that that field does not update (reactivity bug?)
            let desc = document.querySelector(
              "div.promoted-result > div.result-text > div.promoted-description"
            );
            if (desc) {
              desc.textContent = (response.data && response.data.description) ? response.data.description : "";
            }
          });
        })
        .catch(function(err) {
          console.error("Error loading promoted results: " + err.message);
          oThis.isLoading = false;
        });
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.promoted-result {
  display: flex;
  width: 100%;
  box-sizing: border-box;
  outline: 1px solid #c9e6f4;
  background-color: #c9e6f4;
  margin-bottom: 50px;
}

.promoted-result .result-text {
  padding: 30px;
  width: 100%;
  box-sizing: border-box;
}

.promoted-result h5 {
  font-size: 22px;
  line-height: 28px;
  padding-bottom: 7px;
  padding-top: 4px;
}

.promoted-result .promoted-description {
  font-size: 16px;
  line-height: 24px;
  max-height: 48px;
  -webkit-line-clamp: 2;
-webkit-box-orient: vertical;
  overflow: hidden;
  display: -webkit-box;
}

.promoted-result ul {
  margin-top: 30px;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  max-height: 150px;
  overflow: hidden;
}

.promoted-result ul > li {
  width: 50%;
}

.promoted-result ul > li > a.regular-link {
  font-family: "Gotham SSm A", Arial, Helvetica, sans-serif;
  font-size: 14px;
  line-height: 18px;
  color: #323232;
  font-weight: 100;
  flex-grow: 1;
  margin-bottom: 16px;
}

.promoted-result ul > li > a.regular-link:hover {
  font-weight: 700;
}

.promoted-result .result-image {
  height: 300px;
  width: 300px;
  min-width: 300px;
  background-size: cover;
  background-position: 50%;
}

.hidden {
  display: none;
}

@media screen and (min-width: 1281px) {
  .promoted-result {
    max-height: 300px;
  }
}

@media screen and (min-width: 781px) and (max-width: 1280px) {
  .promoted-result {
    max-height: 250px;
  }
  .promoted-result .result-image {
    height: 250px;
    width: 250px;
    min-width: 250px;
  }

  .promoted-result ul {
    max-height: 100px;
  }
}

@media screen and (max-width: 780px) {
  .promoted-result {
    flex-direction: column-reverse;
    max-height: unset;
  }
  .promoted-result .result-image {
    height: calc(100vw - 30px);
    width: calc(100vw - 30px);
    min-width: 250px;
  }

  .promoted-result ul {
    max-height: unset;
  }
}

@media screen and (max-width: 480px) {
  .promoted-result ul > li {
    width: 100%;
    margin-bottom: 10px;
  }
}
</style>
